const question5 = {
    'question': 'Ile trwa jedna sesja terapii?',
    'answer': 'Czas przeznaczony na jedno spotkanie sesji indywidualnej z terapeutą wynosi od 50 minut do godziny.',
}

export default question5;